import { auditTime, combineLatest, Observable, ObservableInputTuple } from 'rxjs';

export function watchStateChanges<A extends readonly unknown[]>(sources: readonly [...ObservableInputTuple<A>]): Observable<A> {
  return combineLatest(sources).pipe(
    auditTime(0) // auditTime must be used to be able to call updateState in subscribe handler below
  )
}
